export default "__VITE_ASSET__$ZZU$Rhw__"